import { render, staticRenderFns } from "./archive-item-faq.vue?vue&type=template&id=14489081&"
import script from "./archive-item-faq.vue?vue&type=script&lang=js&"
export * from "./archive-item-faq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports